// src/pages/produtos/grupos/GrupoCad.js
import React, { useState, useEffect } from 'react';

import { MdOutlineUnfoldMore } from 'react-icons/md';

import GrupoSearch from './GrupoSearch';
import { Grupo } from '../../../models/produtos/Grupo';
import { useGrupo } from '../../../contexts/produtos/GrupoContext';
import Input from '../../../components/input/Input';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import InputCheck from '../../../components/input/InputCheck';
import { useFormHandler } from '../../../hooks/useFormHandler';
import ModalOrdemGrupo from './ModalOrdemGrupo';
import GrupoImagemModal from './GrupoImagemModal';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const GrupoCad = ({ show, onHide }) => {
    const { grupos, addGrupo, updateGrupo, deleteGrupo } = useGrupo();
    const [grupo, setGrupo] = useState(new Grupo());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showModalOrdemGrupo, setShowModalOrdemGrupo] = useState(false);
    const [showGrupoImagemModal, setShowGrupoImagemModal] = useState(false);
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);
    const { isSubmitting, handleSubmit } = useFormHandler();

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setGrupo(new Grupo());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage('Selecione um Grupo para editar!');
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!grupo?.id) {
            showMessage('Selecione um Grupo para excluir!');
        } else {
            const resposta = await showYesNo('Deseja excluir o grupo selecionado?');
            if (resposta) {
                await deleteGrupo(grupo.id);
                handleNovo();
            }
        }
    };

    const handleSave = () => {
        if (!grupo.descricao?.trim()) {
            showMessage('Informe uma descricao para o grupo!');
            return;
        }

        handleSubmit(
            async () => {
                if (!grupo.id) {
                    await addGrupo(grupo);
                } else {
                    await updateGrupo(grupo);
                }
                handleNovo();
            },
            () => {},
            (error) => console.error('Erro ao gravar dados: ', error),
        );
    };

    const handleExit = () => {
        const grupoSel = grupos.find((item) => item.id.toString() === grupo?.id?.toString());

        if (grupoSel) {
            setGrupo(grupoSel);
            handleEditar(grupo?.id);
        } else {
            setGrupo(new Grupo());
        }
    };

    const handleSelectGrupo = (grupoSel) => {
        setGrupo(grupoSel);
        setShowSearchModal(false);
        if (grupoSel) {
            handleEditar(grupoSel.id);
        } else {
            setGrupo(new Grupo());
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Novo Grupo' : 'Alterar Grupo'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Codigo"
                            value={grupo.id || ''}
                            onChange={(e) => setGrupo({ ...grupo, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />
                        <Input
                            label="Descricao"
                            value={grupo.descricao || ''}
                            onChange={(e) => setGrupo({ ...grupo, descricao: e.target.value })}
                            size={300}
                            autoFocus
                        />

                        <InputCheck
                            label="Inativo"
                            checked={grupo.inativo}
                            onChange={(e) => setGrupo({ ...grupo, inativo: e.target.checked })}
                        />

                        <InputCheck
                            label="Venda no App"
                            checked={grupo.vendeApp}
                            onChange={(e) => setGrupo({ ...grupo, vendeApp: e.target.checked })}
                        />

                        <Input
                            label="Cashback %"
                            value={grupo.cashBackPercent || ''}
                            onChange={(e) => setGrupo({ ...grupo, cashBackPercent: e.target.value })}
                            type="number"
                            size={110}
                        />

                        <div className="d-flex align-items-end flex-wrap" style={{ gap: '12px' }}>
                            <div className="form-group mb-0">
                                <label className="form-label">Ordem Exibicao</label>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                    onClick={() => setShowModalOrdemGrupo(true)}
                                    style={{ gap: '6px', minWidth: '140px' }}
                                >
                                    Ordenar <MdOutlineUnfoldMore />
                                </button>
                            </div>

                            <div className="form-group mb-0">
                                <label className="form-label">Imagem</label>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary d-flex align-items-center justify-content-center"
                                    onClick={() => setShowGrupoImagemModal(true)}
                                    style={{ minWidth: '140px' }}
                                >
                                    {grupo.imagemGrupoId || grupo.imagemGrupo?.nome ? 'Editar imagem' : 'Salvar imagem'}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={isSubmitting}
                     action="save">
                        {isSubmitting ? 'Salvando...' : 'Salvar'}
                    </ModalActionButton>
                    <ModalActionButton type="button" className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton type="button" className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <GrupoSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectGrupo={handleSelectGrupo}
            />

            <ModalOrdemGrupo
                show={showModalOrdemGrupo}
                onHide={() => setShowModalOrdemGrupo(false)}
                grupoSelecionado={grupo}
                onGrupoAtualizado={(grupoAtualizado) => setGrupo((prev) => ({
                    ...prev,
                    orderNum: grupoAtualizado.orderNum,
                }))}
            />

            <GrupoImagemModal
                show={showGrupoImagemModal}
                onHide={() => setShowGrupoImagemModal(false)}
                grupo={grupo}
                setGrupo={setGrupo}
            />
        </ModalContainer>
    );
};

export default GrupoCad;
